export default __webpack_public_path__ + "static/media/1023.0b76ae62.png";